import {FilterKeys} from "../enums/filter-keys";

export class FilterVO<T> {
  key: FilterKeys;
  value: T;

  constructor(key: FilterKeys, value: T) {
    this.key = key;
    this.value = value;
  }
}
